import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LineSegments } from '../objects/LineSegments.js';
import { LineBasicMaterial } from '../materials/LineBasicMaterial.js';
import { Float32BufferAttribute } from '../core/BufferAttribute.js';
import { BufferGeometry } from '../core/BufferGeometry.js';
import { Color } from '../math/Color.js';

var PolarGridHelper = /*#__PURE__*/function (_LineSegments) {
  _inherits(PolarGridHelper, _LineSegments);

  var _super = _createSuper(PolarGridHelper);

  function PolarGridHelper() {
    var _this;

    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var radials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    var circles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
    var divisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
    var color1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0x444444;
    var color2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0x888888;

    _classCallCheck(this, PolarGridHelper);

    color1 = new Color(color1);
    color2 = new Color(color2);
    var vertices = [];
    var colors = []; // create the radials

    for (var i = 0; i <= radials; i++) {
      var v = i / radials * (Math.PI * 2);
      var x = Math.sin(v) * radius;
      var z = Math.cos(v) * radius;
      vertices.push(0, 0, 0);
      vertices.push(x, 0, z);
      var color = i & 1 ? color1 : color2;
      colors.push(color.r, color.g, color.b);
      colors.push(color.r, color.g, color.b);
    } // create the circles


    for (var _i = 0; _i <= circles; _i++) {
      var _color = _i & 1 ? color1 : color2;

      var r = radius - radius / circles * _i;

      for (var j = 0; j < divisions; j++) {
        // first vertex
        var _v = j / divisions * (Math.PI * 2);

        var _x = Math.sin(_v) * r;

        var _z = Math.cos(_v) * r;

        vertices.push(_x, 0, _z);
        colors.push(_color.r, _color.g, _color.b); // second vertex

        _v = (j + 1) / divisions * (Math.PI * 2);
        _x = Math.sin(_v) * r;
        _z = Math.cos(_v) * r;
        vertices.push(_x, 0, _z);
        colors.push(_color.r, _color.g, _color.b);
      }
    }

    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
    var material = new LineBasicMaterial({
      vertexColors: true,
      toneMapped: false
    });
    _this = _super.call(this, geometry, material);
    _this.type = 'PolarGridHelper';
    return _this;
  }

  return _createClass(PolarGridHelper);
}(LineSegments);

export { PolarGridHelper };